import styles from "../../../../styles/catalog-tags.module.scss";

import { Button } from "../../../components/Button";
import { Checkbox } from "../../../components/Checkbox";
import { Icon } from "../../../components/core/Icon";
import { Empty } from "../../../components/Empty";

export default function TagsList({
    tags,
    onEditTag,
    onDeleteTag,
    onSelectTag,
    manage = false,
}) {
    return (
        <div className={styles.tagsContainer}>
            <div className={styles.tags}>
                {tags?.length === 0 && (
                    <Empty>
                        <Icon name="tags" size="4x" />
                        <p>Você ainda não possui tags no cardápio</p>
                        {!!manage && (
                            <span>
                                Para adicionar, clique no botão Criar Tag
                                abaixo.
                            </span>
                        )}
                    </Empty>
                )}
                {tags?.length > 0 &&
                    (!!manage ? (
                        <span className="mb-30">Tags criadas</span>
                    ) : (
                        <span className="mb-30">
                            Selecione as tags deste produto:
                        </span>
                    ))}
                {tags.map((tag, index) => {
                    return (
                        <div className={styles.tag} key={index}>
                            {!manage && (
                                <div className="mr-15">
                                    <Checkbox
                                        checked={tag?.checked}
                                        onChange={() => onSelectTag && onSelectTag(tag)}
                                    />
                                </div>
                            )}
                            <div className={styles.icon}>
                                {tag.iconUrl ? (
                                    <img
                                        src={
                                            process.env.REACT_APP_ASSETS_URL +
                                            `/` +
                                            tag.iconUrl
                                        }
                                        alt={tag.name}
                                    />
                                ) : (
                                    <Icon
                                        name="image-polaroid"
                                        size="2x"
                                        light
                                    />
                                )}
                            </div>

                            <div className={styles.column}>
                                <span>{tag.name}</span>
                            </div>

                            {!!manage && (
                                <div className={styles.column}>
                                    <div className={styles.actions}>
                                        <Button
                                            design="default-icon-mini"
                                            onClick={() =>
                                                onEditTag && onEditTag(tag)
                                            }
                                        >
                                            <Icon name="pen" size="1x" />
                                        </Button>
                                        <Button
                                            design="default-icon-mini"
                                            onClick={() =>
                                                onDeleteTag && onDeleteTag(tag)
                                            }
                                        >
                                            <Icon name="trash-alt" size="1x" />
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
